var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
//@ts-ignore: Used as Jquery plugin
import bootstrapSelect from "bootstrap-select/js/bootstrap-select";
import * as Ladda from "ladda";
import { initLaddaButtons, initQtyInputGroups } from "../components/forms";
import Swal from "sweetalert2";
import { initProductGallery } from "../components/productGallery";
//@ts-ignore: This is just to make Bootstrap select work in a TSX file
const bss = bootstrapSelect;
$(function () {
    if ($("#product-form").length) {
        initProductForm();
    }
    if ($(".quick-view-btn").length) {
        initQuickView();
    }
    if ($(".diet-filters").length) {
        initFilterSystem();
    }
    // if($(".shop-category-nav").length){
    //     //init Desktop tag selector
    //     console.log("1")
    // }
    // if($("#selectNav").length){
    //     //init Mobile select dropdown for tags
    //     console.log("2")
    // }
});
function initProductForm(options) {
    $("#product-form").on("submit", (function (e) {
        e.preventDefault();
        //Send form data to cart page
        const formData = $(this).serialize(); // new FormData(document.getElementById("product-form") as HTMLFormElement)
        $.post("/cart", formData, function (data) {
            //@ts-ignore
            if (typeof Ladda !== "undefined")
                Ladda.stopAll();
            if (options && options.callback)
                options.callback();
            const dataObj = JSON.parse(data);
            const itemQty = dataObj.itemQuantity;
            $("#cart-count-badge").text(itemQty);
            $("#cart-count-badge").removeClass("d-none");
            if (dataObj.klaviyo) {
                //@ts-ignore: Klaviyo is a global object
                klaviyo.push(["track", "Added to Cart", dataObj.klaviyo]);
                console.log("Klaviyo added to cart", dataObj.klaviyo);
            }
            Swal.mixin({
                customClass: {
                    confirmButton: "btn btn-cta",
                    cancelButton: "btn btn-secondary"
                },
                buttonsStyling: false
            }).fire({
                title: "Product added to cart",
                icon: "success",
                showCancelButton: true,
                confirmButtonText: "View cart",
                cancelButtonText: "Close",
                footer: $("#return-link-holder").html(),
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.assign("/cart");
                }
            });
        });
        //return false
    }));
    $("#product-subscription-add-btn").on("click", (function (e) {
        e.preventDefault();
        //Fire off a request to see how many subscriptions the current user has
        $.post("/ajax/getCustomerSubscriptions", (subscriptions) => __awaiter(this, void 0, void 0, function* () {
            if (subscriptions.length == 0) {
                //No subscriptions found.. Show error
            }
            else if (subscriptions.length == 1) {
                //Single subscription found.. Use it
                processAddToSubscription(subscriptions[0].uuid);
            }
            else {
                //Multiple subscriptions found.. Ask user which to use
                const { value } = yield Swal.fire({
                    html: "As you have multiple subscriptions, please choose the subscription to add this product to",
                    input: "select",
                    inputOptions: subscriptions.reduce((obj, item) => {
                        const displayDate = new Date(item.next_delivery_date).toLocaleDateString();
                        return Object.assign(Object.assign({}, obj), { [`${item.uuid}`]: `Subscription #${item.id}, next ${item.collection ? 'collection' : 'delivery'} on ${displayDate}` });
                    }, {}),
                    didOpen: () => {
                        initLaddaButtons();
                    },
                    customClass: {
                        confirmButton: "btn btn-success ladda-button",
                        cancelButton: "btn btn-default"
                    },
                    preConfirm: (value) => __awaiter(this, void 0, void 0, function* () {
                        Swal.showLoading();
                        processAddToSubscription(value);
                        return false;
                    }),
                    showCancelButton: true,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                });
                if (typeof value === "undefined") {
                    if (typeof Ladda !== "undefined")
                        Ladda.stopAll();
                }
            }
        }));
    }));
    $(".variant_select").click(function (e) {
        var selectedVariantId = $(this).val();
        var selectedSKU = $(this).data("sku");
        $("[id^='variant-']").each(function (el) {
            //var variantId = $(this).data("variant-id")
            if ($(this).attr("id") == `variant-${selectedVariantId}`) {
                $(this).show();
                //'$("#product_variant_id").val(selectedVariantId)
                history.replaceState(null, "", "?variant=" + selectedSKU);
            }
            else {
                $(this).hide();
            }
        });
    });
}
function initQuickView() {
    //@ts-ignore
    const quickViewModal = new bootstrap.Modal("#quickViewModal", {
        keyboard: false
    });
    $(".quick-view-btn").on("click", function () {
        const id = $(this).data("id");
        const title = $(this).data("title");
        const url = $(this).data("url");
        //Update title and body
        $("#quickViewModalLabel").html(title);
        $("#quickViewModal .modal-body").load(`${url} #product-form`, function () {
            //@ts-ignore
            if (typeof Ladda !== "undefined")
                Ladda.stopAll();
            quickViewModal.show(); //Show modal
            initProductForm({
                callback: () => quickViewModal.hide()
            }); //Init products form
            initQtyInputGroups(); //Init qty input groups
            initProductGallery(); //Initi Splide gallery script
            //Finally, enable ladda script on submit btn
            Ladda.bind("#product-submit-btn");
        });
    });
}
function processAddToSubscription(uuid) {
    //Update the way the form is processed
    $("#product-form").attr("action", `/account/subscriptions/${uuid}`);
    $("#product-form").append(`<input type="hidden" name="action-add-line" value="true" />`);
    setTimeout(() => {
        //Unbind the current submit event, and post form in a regular way
        $("#product-form").off("submit").trigger("submit");
    }, 300);
}
function initFilterSystem() {
    const LIMIT_SINGLE_TAG = true;
    // ─── Tag Selected Or Deselected ──────────────────────────────────────
    $(".diet-filters input[type='checkbox']").on("change", function () {
        const selectedItem = $(this);
        if (LIMIT_SINGLE_TAG) {
            $(".diet-filters input[type='checkbox']").each(function () {
                if ($(this)[0] !== selectedItem[0]) {
                    $(this).prop("checked", false);
                }
            });
        }
        updateProductGrid();
    });
    // ─── Category Selected ───────────────────────────────────────────────
    $(".shop-category-nav a.nav-link").on("click", function (e) {
        e.preventDefault();
        const selectedItem = $(this);
        $(".shop-category-nav a.nav-link").each(function () {
            if ($(this)[0] === selectedItem[0]) {
                $(this).addClass("active");
            }
            else {
                $(this).removeClass("active");
            }
        });
        updateProductGrid();
    });
    // ─── Pagination ──────────────────────────────────────────────────────
    $("body").on("click", ".pagination .page-item a", function (e) {
        e.preventDefault();
        const url = $(this).prop("href");
        updateProductGrid(url);
    });
    // ─── Allergen Selections ─────────────────────────────────────────────
    if ($("#allergen-shop-filter").length > 0) {
        let values = $("#allergen-shop-filter").val();
        $("#allergen-shop-filter")
            .selectpicker({
            multipleSeparator: ", ",
            noneSelectedText: "Allergens",
            selectedTextFormat: "count > 5",
            iconBase: "fa-regular",
            tickIcon: "fa-xmark"
        })
            .on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
            console.log("CHANGED");
        });
        // $("body").on("click", function(e){
        //     const isEqual = _.isEqual($("#allergen-shop-filter").val(), values)
        //     if( !isEqual ){
        //         values = $("#allergen-shop-filter").val()
        //         updateProductGrid()
        //     }
        // })        
    }
    // ─── Meat Filter Selections ──────────────────────────────────────────
    if ($("#meat-shop-filter").length > 0) {
        let values = $("#meat-shop-filter").val();
        $("#meat-shop-filter")
            .selectpicker({
            multipleSeparator: ",",
            noneSelectedText: "Filter",
            selectedTextFormat: "count > 2",
            iconBase: "fa-regular",
            tickIcon: "fa-xmark"
        })
            .on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
            console.log("CHANGED");
        });
        // $("body").on("click", function(e){
        //     const isEqual = _.isEqual($("#meat-shop-filter").val(), values)
        //     if( !isEqual ){
        //         values = $("#meat-shop-filter").val()
        //         updateProductGrid()
        //     }
        // })        
    }
    // ─── Toggle And Submit Buttons ───────────────────────────────────────
    $("body").on("click", "#btn-filter-toggle", function (e) {
        e.preventDefault();
        if ($("#additional-filters").is(":hidden")) {
            $("#additional-filters").slideDown();
        }
        else {
            $("#additional-filters").slideUp();
        }
    });
    $("body").on("click", "#btn-filter-update", function (e) {
        e.preventDefault();
        $("#additional-filters").slideUp();
        updateProductGrid();
    });
}
function updateProductGrid(url) {
    window.scrollTo(0, 0);
    showLoader();
    if (typeof url == "undefined") {
        url = $(".shop-category-nav a.nav-link.active").prop("href")
            + "?" + $(".shop-filters-horizontal form").serialize();
    }
    window.history.pushState(null, url, url);
    $("#shop-grid-data").load(`${url} #shop-grid-data`, function () {
        initQuickView();
        hideLoader();
    });
}
function showLoader() {
    $("#page-loader").fadeIn("fast");
}
function hideLoader() {
    $("#page-loader").fadeOut("fast");
}
